import { Pipe, PipeTransform } from '@angular/core';
import { PredefinedEmissionPlace } from '../types/predefined-emission-place.types';

@Pipe({
  name: 'appEmissionPlace'
})
export class EmissionPlacePipe implements PipeTransform {
  public transform(emissionPlace: string | undefined): string {
    return (emissionPlace && Object.keys(PredefinedEmissionPlace).includes(emissionPlace))
      ? `COMMON.PREDEFINED_EMISSION_PLACES.${emissionPlace}`
      : String(emissionPlace);
  }
}
